export default "__VITE_ASSET__CF$9geJ1__"